import { render, staticRenderFns } from "./ImageBubbleMenu.vue?vue&type=template&id=4c1aee49&scoped=true"
import script from "./ImageBubbleMenu.vue?vue&type=script&lang=js"
export * from "./ImageBubbleMenu.vue?vue&type=script&lang=js"
import style0 from "./ImageBubbleMenu.vue?vue&type=style&index=0&id=4c1aee49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1aee49",
  null
  
)

export default component.exports